import { Entity } from 'src/app/core/data/schema/entity';
import { Utilities } from 'src/app/core/helper/util';

/**
 * Page Group Mappings are used to restrict access to pages by 
 */
export class PageAccessMapping extends Entity {

    static className = 'PageAccessMapping';
    static idField = 'pageAccessMappingId';

    pageAccessMappingId: number = 0;
    pageId: number;
    membershipId: number;
    communityGroupId: number;
    registeredUsers: boolean = false;

    // extra values mapped in API
    membershipName: string;
    communityGroupName: string;

    constructor(pageAccessMapping?: Partial<PageAccessMapping>) {
        super();
        Object.assign(this, pageAccessMapping);

        this.pageAccessMappingId = Utilities.getRandomNumber(5);
    }

    // ----------------------------------------------------
    // Service-like features from here on down
    // ----------------------------------------------------

    private static _cachedForParentId: number; // keep track of which page the blocks are for 
    private static _cachedServerObjs: PageAccessMapping[]; // unmodified until saved
    private static _cachedObjs: PageAccessMapping[]; // working copy

    // get all the child records for a specific parent, these will be cached for the last parent
    // that they were requested for
    public static async fetchForPage(pageId: number) {
        return await PageAccessMapping.fetchChildrenFor(PageAccessMapping, pageId, null, `forPage/${pageId}`); 
    }

    
}
